import React, { useEffect, useState } from 'react'
import { CheckBox, CheckBoxLabel } from './styled'
import Box from '../Box'
import { ToggleProps } from './Toggle.types'

const Toggle: React.FC<ToggleProps> = ({ checked = false, onChange, ...restProps }) => {
  const [isChecked, setIsChecked] = useState<boolean>(checked)

  useEffect(() => {
    setIsChecked(checked)
  }, [checked])

  const onToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked((event.target as HTMLInputElement).checked)
    onChange((event.target as HTMLInputElement).checked, event)
  }

  return (
    <Box position='relative'>
      <CheckBox checked={checked || isChecked} type='checkbox' onChange={onToggle} {...restProps} />
      <CheckBoxLabel htmlFor='checkbox' />
    </Box>
  )
}

export default Toggle
